import React, { useState } from 'react';

const ConfirmedAction = ({ trigger, confirmation, onConfirm, onCancel }) => {
    const [showConfirmation, setShowConfirmation] = useState(false);
    const handleClick = () => {
        setShowConfirmation(true);
    };
    const handleConfirm = () => {
        setShowConfirmation(false);
        onConfirm();
    };
    const handleCancel = () => {
        setShowConfirmation(false);
        if (onCancel)
            onCancel();
    };
    return (React.createElement(React.Fragment, null,
        showConfirmation && confirmation(handleConfirm, handleCancel),
        trigger(handleClick, showConfirmation)));
};

export { ConfirmedAction };
